module.exports = __webpack_public_path__ + "static/media/swordman-green.74524d68.svg";